import React from "react";
import CompaniesTable from "../Components/Companies/CompaniesTable";

const CompaniesPage = () => {
  return <CompaniesTable />;
};

export default CompaniesPage;
